import { Dispatch } from "redux";
import request from "../../Requests/requests";
import { UserAuthActionTypes, UserAuthTypeAction } from "./userStore";

export const FETCH_DATA_REQUEST_USER_ACCOUNT = 'FETCH_DATA_REQUEST_USER_ACCOUNT';
export const FETCH_DATA_RESPONSE_USER_ACCOUNT = 'FETCH_DATA_RESPONSE_USER_ACCOUNT';
export const FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR = 'FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR';

export const getUserData = () => {    
    return async (dispatch: Dispatch<UserAuthTypeAction>) => {
        dispatch({ type: UserAuthActionTypes.FETCH_DATA_REQUEST_USER_ACCOUNT })

        return await request.get('/Account/User/', { params: {
            UserId: localStorage.getItem('userID')}})
            .then(response => response.data)
            .then(data => {
                dispatch({ type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT, payload: data})
            })
            .catch(error => {                
                dispatch({ type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR , payload: error})
            })
    }
}